export var WdUnderlyingType;
(function (WdUnderlyingType) {
    WdUnderlyingType[WdUnderlyingType["ENTITY"] = 0] = "ENTITY";
    WdUnderlyingType[WdUnderlyingType["STRING"] = 1] = "STRING";
    WdUnderlyingType[WdUnderlyingType["TIME"] = 2] = "TIME";
    WdUnderlyingType[WdUnderlyingType["QUANTITY"] = 3] = "QUANTITY";
    WdUnderlyingType[WdUnderlyingType["GLOBE_COORDINATE"] = 4] = "GLOBE_COORDINATE";
})(WdUnderlyingType || (WdUnderlyingType = {}));
export var WdDatatype;
(function (WdDatatype) {
    WdDatatype[WdDatatype["ITEM"] = 0] = "ITEM";
    WdDatatype[WdDatatype["PROPERTY"] = 1] = "PROPERTY";
    WdDatatype[WdDatatype["LEXEME"] = 2] = "LEXEME";
    WdDatatype[WdDatatype["SENSE"] = 3] = "SENSE";
    WdDatatype[WdDatatype["FORM"] = 4] = "FORM";
    WdDatatype[WdDatatype["MONOLINGUAL_TEXT"] = 5] = "MONOLINGUAL_TEXT";
    WdDatatype[WdDatatype["STRING"] = 6] = "STRING";
    WdDatatype[WdDatatype["EXTERNAL_IDENTIFIER"] = 7] = "EXTERNAL_IDENTIFIER";
    WdDatatype[WdDatatype["URL"] = 8] = "URL";
    WdDatatype[WdDatatype["COMMONS_MEDIA_FILE"] = 9] = "COMMONS_MEDIA_FILE";
    WdDatatype[WdDatatype["GEOGRAPHIC_SHAPE"] = 10] = "GEOGRAPHIC_SHAPE";
    WdDatatype[WdDatatype["TABULAR_DATA"] = 11] = "TABULAR_DATA";
    WdDatatype[WdDatatype["MATHEMATICAL_EXPRESSION"] = 12] = "MATHEMATICAL_EXPRESSION";
    WdDatatype[WdDatatype["MUSICAL_NOTATION"] = 13] = "MUSICAL_NOTATION";
    WdDatatype[WdDatatype["QUANTITY"] = 14] = "QUANTITY";
    WdDatatype[WdDatatype["POINT_IN_TIME"] = 15] = "POINT_IN_TIME";
    WdDatatype[WdDatatype["GEOGRAPHIC_COORDINATES"] = 16] = "GEOGRAPHIC_COORDINATES";
})(WdDatatype || (WdDatatype = {}));
//# sourceMappingURL=wd-property.js.map